<template>
  <div class="change_phone">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>修改绑定手机</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm">
        <table border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>手机号码:</td>
            <td>
              <el-form-item label="" prop="phone">
                <div class="input_code">
                  <el-input
                    v-model="form.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                  <el-button v-show="showCode" @click="getPhoneCode"
                    >免费获取验证码</el-button
                  >
                  <el-button disabled v-show="!showCode"
                    >还剩{{ auth_time }}秒</el-button
                  >
                </div>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>验证码:</td>
            <td>
              <el-form-item label="" prop="phonecode">
                <el-input
                  v-model="form.phonecode"
                  placeholder="请输入短信验证码"
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>图形验证码:</td>
            <td>
              <el-form-item label="" prop="code">
                <div class="input_code">
                  <el-input
                    v-model="form.code"
                    placeholder="请输入图形验证码"
                  ></el-input>
                  <div v-if="imgurl" @click="_httpGetCode(csrf)">
                    <img
                      style="height: 40px; width: 100px"
                      :src="imgurl"
                      alt=""
                    />
                  </div>
                </div>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center">
              <el-button>取消</el-button>
              <el-button type="primary" @click="submitForm">提交</el-button>
            </td>
          </tr>
        </table>
      </el-form>
      <table border="1" cellspacing="0" cellpadding="0">
        <tr>
          <td>请注意:</td>
          <td>
            若您所绑定的手机号已无法正常接收短信，请您下载《用户修改绑定手机申请表》，信息填写完整并加盖公章后，
            按照表上要求发送至产品认证客户服务部，人工审核通过后将为您进行修改。
          </td>
        </tr>
        <tr>
          <td>请下载:</td>
          <td>
            <a href="http://" target="_blank"> 《用户修改绑定手机申请表》</a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { httpGetCode, httpGetphone } from "../../utils/login";
import { httpUserChangephone } from "../../utils/personalsetting";
export default {
  data() {
    //手机号格式校验
    const phoneCheck = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        this.isphone = true;
        callback();
      }
    };
    return {
      csrf: sessionStorage.getItem("csrf"),
      showCode: true, //控制获取验证码按钮的显示隐藏
      auth_time: "",
      isphone: false, //倒计时逻辑控制
      imgurl: "",
      form: {
        phone: "",
        phonecode: "",
        code: "",
      },
      rules: {
        phone: [{ required: true, validator: phoneCheck, trigger: "blur" }],
        phonecode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //验证码倒计时
    getPhoneCode() {
      if (this.isphone == true) {
        this.showCode = false;
        this.auth_time = 60;
        let auth_timer = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.showCode = true;
            this.isphone = false;
            clearInterval(auth_timer);
          }
        }, 1000);
        this._httpGetphone(this.form.phone, "changePhone", this.csrf);
        this.isphone = false;
      } else {
        this.$message("请输入有效的手机号");
      }
    },
    //发送修改绑定手机
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            phone: this.form.phone,
            verifyCode: this.form.code,
            phoneVerifyCode: this.form.phonecode,
            csrf: this.csrf,
          };
          this._httpUserChangephone(data);
        } else {
          return false;
        }
      });
    },
    //修改绑定手机
    _httpUserChangephone(data) {
      httpUserChangephone(data).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.$message.success(data.data);
        } else {
          this.$message(data.msg);
        }
      });
    },
    //获取短信验证码
    _httpGetphone(phone, style, csrf) {
      httpGetphone(phone, style, csrf).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.$message.success(data.data);
        } else {
          this.$message(data.msg);
        }
      });
    },
    //获取图片验证码
    _httpGetCode(csrf) {
      httpGetCode(csrf).then((res) => {
        this.imgurl = window.URL.createObjectURL(res.data);
      });
    },
  },
  mounted() {
    this._httpGetCode(sessionStorage.getItem("csrf"));
  },
};
</script>

<style lang="scss" scoped>
.change_phone {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    table {
      width: 100%;
      height: 200px;
      margin-top: 20px;
      border: 1px solid #eee;
      tr {
        td {
          height: 70px;
          padding: 0 15px;
          p {
            margin: 20px;
            line-height: 20px;
          }
          /deep/ .el-input {
            width: 30%;
            border-radius: 0px !important;
          }
          /deep/ .el-form-item {
            margin-bottom: 0 !important;
          }
          /deep/ .el-form-item__error {
            padding-top: 0 !important;
          }
          a {
            text-decoration: none;
            color: #62b3ff;
          }
          .input_code {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img {
              vertical-align: middle;
            }
          }
        }
        td:first-of-type {
          width: 30%;
        }
      }
    }
  }
}
</style>